/**
 * Returns time in minutes from DisplayDate object obtained from TimePicker component.
 * @newDisplayDate: DisplayDate object which is used to get time in minutes
 */
var getMinutesFromDisplayDate = function (newDisplayDate) {
    return newDisplayDate.getHours() * 60 + newDisplayDate.getMinutes();
};
export default getMinutesFromDisplayDate;
//# sourceMappingURL=getMinutesFromDisplayDate.js.map